export const quotesAnimation = {
  initial: {
    opacity: 0,
    y: 40,
  },
  opacityIn: {
    opacity: 1,
    transition: {
      duration: 0.77,
      ease: 'linear',
    },
  },
  transformIn: {
    y: 0,
    transition: {
      duration: 1.63,
      ease: 'easeInOut',
    },
  },
}

export const textAnimation = {
  initial: {
    opacity: 0,
    y: 40,
  },
  opacityIn: {
    opacity: 1,
    transition: {
      duration: 0.73,
      ease: 'linear',
      delay: 0.2,
    },
  },
  transformIn: {
    y: 0,
    transition: {
      duration: 1.63,
      ease: 'easeInOut',
      delay: 0.2,
    },
  },
}

export const artistAnimation = {
  initial: {
    opacity: 0,
    y: 40,
  },
  opacityIn: {
    opacity: 1,
    transition: {
      duration: 0.73,
      ease: 'linear',
      delay: 0.43,
    },
  },
  transformIn: {
    y: 0,
    transition: {
      duration: 1.63,
      ease: 'easeInOut',
      delay: 0.43,
    },
  },
}
